<template>
	<div class="postition-comp">
		<div class="postition-comp-wrap">
			<div class="postition-comp-header">
				<div class="postition-comp-title">选择位置</div>
				<div class="postition-comp-h-opts">
					<span @click="close">关闭</span>
				</div>
			</div>
			<div class="postition-comp-search">
				<input type="text" v-model="requestParam.kewords" placeholder="搜索">
			</div>
			<div class="postition-comp-box" id="postition-comp-box">
				<div class="postition-comp-items">
					<div class="postition-comp-item" v-for="map in mapList">
						<div class="postition-comp-item-field postition-comp-item-field-h" :title="map.title">{{map.title}}</div>
						<div class="postition-comp-item-field postition-comp-item-field-h" :title="map.address">{{map.address}}</div>
						<div class="postition-comp-item-field postition-comp-item-field-choose">
							<button @click="selectMap(map)">选择</button>
						</div>
					</div>
				</div>
			</div>
			<div class="postition-comp-page">
				<page-component 
					:dataApi="dataApi" 
					:requestParams="requestParam" 
					@page-call="pageCall($event)" 
					key="cirle-map-page"
					ref="CircleMapPage">
				</page-component>
			</div>
		</div>
	</div>
</template>

<script>
	import PageComponent from './PageComponent.vue'
	import {webGetMapsList} from '../network/web/maps.js'
	
	export default{
		name:'PositionComp',
		components:{
			PageComponent
		},
		data(){
			return{
				dataApi: webGetMapsList,
				requestParam:{
					kewords: '',
					start_time:'',
					end_time:'',
					prePage: 10
				},
				mapList:[]
			}
		},
		methods:{
			//关闭页面
			close(){
				this.$emit("close-circle-remind")
			},
			
			// 选择坐标点
			selectMap(map){
				let eData = {
					lat: map.latitude,
					lng: map.longitude,
					title: map.title,
					address: map.address,
					qq_map: map.qqmap
				}
				this.$emit('map-call',eData)
			},
			
			// 分页数据回调
			pageCall(data){
				let n_data = []
				for (let i = 0; i < data.length; i++) {
					n_data.push({
						id: data[i].id,
						title: data[i].title,
						address: data[i].address,
						latitude: data[i].latitude,
						longitude: data[i].longitude,
						qqmap: data[i].qqmap
					})
				}
				this.mapList = n_data
				this.$nextTick(()=>{
					document.getElementById('postition-comp-box').scrollTop = 0
				})
			},
		},
		watch:{
			'requestParam.kewords'(nVal){
				this.$refs['CircleMapPage'].initPage()
			}
		}
	}
</script>

<style>
	.postition-comp{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
		max-width: 1300px;
		margin: 0 auto;
	}
	.postition-comp-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: flex-start;
	}
	.postition-comp-wrap .postition-comp-header{
		height: 44px;
		line-height: 44px;
		border-bottom: 1px solid #eaeaea;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		background-color: #eeeeee;
	}
	.postition-comp-header .postition-comp-h-opts span{
		cursor: pointer;
		display: inline-block;
		height: 34px;
		line-height: 34px;
		padding: 5px;
		user-select: none;
	}
	.postition-comp-box{
		flex: 1;
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
		padding: 0 10px;
	}
	.postition-comp-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-bottom: 1px solid #eaeaea;
	}
	.postition-comp-item-field{
		width: 200px;
		padding: 0 10px;
		line-height: 40px;
	}
	.postition-comp-item-field-h{
		height: 40px;
		overflow: hidden;
		flex-grow: 1;
	}
	.postition-comp-item-field-choose{
		width: 100px;
	}
	.postition-comp-item-field button{
		margin-left: 10px;
		padding: 2px 10px;
		border-radius: 2px;
		background-color: #009E94;
		color: #FFFFFF;
		cursor: pointer;
		font-size: 12px;
	}
	.postition-comp-page{
		padding: 10px 0;
	}
	.postition-comp-search{
		padding: 10px 20px;
	}
	.postition-comp-search input{
		width: 100%;
		max-width: 300px;
		line-height: 26px;
		border: 1px solid #eaeaea;
		padding: 0 5px;
		box-sizing: border-box;
		border-radius: 2px;
	}
	.postition-comp-search input:focus{
		border: 1px solid #009E94;
	}
</style>
